<template>
  <div :class="showList ? 'jy-common-upload-show-list' : 'jy-common-upload-hide-list'">
    <el-upload
        :action="upLoadUrl"
        :list-type="listType"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :http-request="uploadSectionFile"
        :before-upload="handleBeforeUpload"
        :file-list="fileLists"
        multiple
        :limit="limit"
        ref="upload"
        :accept="fileType"
        :drag="isdrag"
        @update:file-list="val => $emit('update:fileList', val)"
    >
      <div v-if="showBtns">
        <i v-if="listType == 'picture-card'" class="el-icon-plus"><span>+</span></i>
        <el-button size="large" v-if="listType == 'picture'" type="primary">{{
            title
          }}</el-button>
        <el-button v-if="listType == 'text'" size="small">选择文件</el-button>
      </div>
      <div v-if="isdrag">
        <el-image
            v-if="ImageUrl"          style="width: 300px; height: 60px"
            fit="scale-down"
            :src="ImageUrl"
        ></el-image>
        <div v-else class="el-upload__text">
          拖拽文件进来 或者<em>点击上传</em>
        </div>
      </div>
      <template #tip>
        <div class="el-upload__tip">
          请上传jpg / png 格式的图片文件
        </div>
      </template>
    </el-upload>

    <el-dialog
        width="60%"
        :visible.sync="disShowImgs"
        append-to-body
    >
      <el-image        style="width: 100%; height: 50vh"
                       fit="scale-down"
                       :src="dialogImageUrl"
      ></el-image>
    </el-dialog>
  </div>
</template>

<script>import { Api }  from "@/assets/js/api";
import utils from "@/assets/js/tool";
import config from "@/assets/js/comm";

export default {
  name: "UploadImgs",
  props: {
    fileNameLists: {
      type: Array,
      default() {
        return [];
      },
    },
    isdrag: {
      type: Boolean,
      default: false,
    },
    showBtns: {
      type: Boolean,
      default: true,
    },
    showList: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "点击上传",
    },
    limit: {
      type: Number,
      default: 9,
    },
    fileSize: {
      type: Number,
      default: 100,
    },
    listType: {
      type: String,
      default: "picture-card",
    },
    fileType: {
      type: String,
      default: "*",
    },
    ImageUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      upLoadUrl: config.uploadUrl,
      dialogImageUrl: "",
      disShowImgs: false,
      fileLists: this.fileNameLists || [],
    };
  },
  watch: {
    fileNameLists(newVal) {
      this.fileLists = newVal;
    },
    fileLists(newVal) {
      this.$emit("update:fileList", newVal);
    },
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.disShowImgs = true;
    },
    handleRemove(file, fileList) {
      // 可选：处理删除逻辑
    },
    uploadSectionFile(param) {
      const file = param.file;
      const fileName = file.name;
      const form = new FormData();
      form.append("file", file);
      form.append("fileName", fileName);
      let sign = utils.getSign({ fileName });
      form.append("sign", sign);

      let loading = this.$loading({
        lock: true,
        text: "上传中...",
        background: "rgba(255, 255, 255, 0)",
      });

      Api.uploadFile(form).then((res) => {
        loading.close();
        if (res.data.status === "success") {
          let obj = {
            fileName: fileName,
            name: res.data.result.fileName,
            url: res.data.result.url,
            operationType: "ADD",
          };
          this.fileLists.push(obj);
          this.$emit("input", this.fileLists);
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(() => {
        loading.close();
        this.$message.error("上传失败");
      });
    },
    handleBeforeUpload(file) {
      if (this.limit === 0) {
        this.fileLists = [];
        this.$refs.upload.clearFiles();
      }

      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
  },
};
</script>


<style>
</style>